(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["table-view-3"] && !Shopify.designMode) return;
  try {
    
// Any JavaScript related to this section can be added here.

document.addEventListener('DOMContentLoaded', function() {
  var filters = document.querySelectorAll('.filter-select');
  filters.forEach(filter => {
    filter.addEventListener('change', function() {
      applyFilters();
    });
  });

  function applyFilters() {
    var activeFilters = {};
    filters.forEach(filter => {
      if (filter.value) {
        activeFilters[filter.dataset.data-filter-key] = filter.value;
      }
    });

    document.querySelectorAll('.buying-chart-row').forEach(row => {
      var showRow = true;
      for (var key in activeFilters) {
        var cell = row.querySelector('.cell[data-key="' + key + '"]');
        if (!cell || cell.textContent.trim() !== activeFilters[key]) {
          showRow = false;
          break;
        }
      }
      row.style.display = showRow ? '' : 'none';
    });
  }
});
  

  } catch(e) { console.error(e); }
})();
})();
